import { ReactComponent as IconDarkFodler } from '@/assets/svgs/dark-folder.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import useFolders from '@/hooks/use-folder/index'
import { useLocation } from '@/lib/router-dom'
import rem from '@/utils/rem'
import React from 'react'

export default function CreateFolderModal({ visible, close }) {
	const [name, setName] = React.useState('')
	const [error, setError] = React.useState('')
	const { currentPath } = useLocation()
	const { create, loading } = useFolders()

	const validateFolderName = (name) => {
		let regex = /^[\w\-\s]+$/
		setError(
		regex.test(name)
			? ''
			: 'Please enter allowed characters Alphabetical, Numeric, Hiphen - or Space',
		)
	}

	const handleCreateFolderSubmit = async () => {
		const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'
		await create(type, {
			folderName: name,
		})
		document.getElementById('reload-eclips')?.click();
		setName('')
		close()
	}

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDarkFodler />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Creating New Folder
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-receipient__input">
						<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
							Name of Folder
						</span>
						<input
							type="text"
							onChange={(e) => {
							setName(e.target.value)
							validateFolderName(e.target.value)
							}}
							value={name}
							maxLength={32}
							placeholder="Name of Folder"
						/>
						{error && name !== '' && (
							<span className="error error-text">{error}</span>
						)}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
						text="Confirm"
						loading={loading}
						disabled={loading || name === '' || error !== ''}
						submit={handleCreateFolderSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
